import { connect } from 'react-redux';
import React, { PropTypes } from 'react';
import {
  Dropdown,
  Form,
  FormDropdown,
  Input,
  Segment,
  TextArea,
} from 'semantic-ui-react';
import CleanableDatepicker from 'common/components/CleanableDatepicker';
import Timepicker from 'common/components/Timepicker';
import { getTimeUnits, getWorkers } from '../reducers/requirements';
import { fetchRequirements } from '../actions/requirements';
import {
  getPlanningDate,
  getPlanningTime,
  getPreplanningDate,
  getPrimaryWorkerId,
  getSecondaryWorkerIds,
  getInterventionTime,
  getInterventionTimeUnit,
  getPlanifConstraints,
  getInternalComment,
  getStatus,
} from '../reducers/form';
import {
  fetchFormIfNeeded,
  updateInternalComment,
  updateInterventionTime,
  updateInterventionTimeUnit,
  updatePlanifConstraints,
  updatePlanningDate,
  updatePlanningTime,
  updatePreplanningDate,
  updateSecondaryWorkerIds,
  updateWorkerId,
} from '../actions/form';
import PreplannificationInput from 'saas/aast/common/components/PreplannificationInput';

const mapStateToProps = (state, ownProps) => ({
  timeUnits: getTimeUnits(state),
  workers: getWorkers(state),
  interventionTime: getInterventionTime(state),
  interventionTimeUnit: getInterventionTimeUnit(state),
  planningDate: getPlanningDate(state),
  planningTime: getPlanningTime(state),
  preplanningDate: getPreplanningDate(state),
  workerId: getPrimaryWorkerId(state),
  secondaryWorkerIds: getSecondaryWorkerIds(state),
  planifConstraints: getPlanifConstraints(state),
  internalComment: getInternalComment(state),
  status: getStatus(state),
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  fetchForm: id => dispatch(fetchFormIfNeeded(ownProps.id)),
  fetchRequirements: () => dispatch(fetchRequirements(ownProps.caseId)),
  updatePlanningDate: date => dispatch(updatePlanningDate(date)),
  updatePlanningTime: time => dispatch(updatePlanningTime(time)),
  updateInterventionTime: duration =>
    dispatch(updateInterventionTime(duration)),
  updateInterventionTimeUnit: unit =>
    dispatch(updateInterventionTimeUnit(unit)),
  updatePreplanningDate: date => dispatch(updatePreplanningDate(date)),
  updateWorkerId: id => dispatch(updateWorkerId(id)),
  updateSecondaryWorkerIds: ids => dispatch(updateSecondaryWorkerIds(ids)),
  updatePlanifConstraints: value => dispatch(updatePlanifConstraints(value)),
  updateInternalComment: value => dispatch(updateInternalComment(value)),
});

export class Page extends React.Component {
  constructor(props) {
    super(props);

    this._renderPrimaryWorkersOptions = this._renderPrimaryWorkersOptions.bind(
      this
    );
  }

  componentWillMount() {
    this.props.fetchRequirements();
    this.props.fetchForm();
  }

  _renderPrimaryWorkersOptions() {
    return this.props.workers.map(w => ({
      key: w.id,
      text: w.display_name,
      value: w.id,
    }));
  }

  _renderSecondaryWorkersOptions() {
    return this.props.workers
      .filter(
        w => this.props.workerId === undefined || this.props.workers !== w.id
      )
      .map(w => ({
        key: w.id,
        text: w.display_name,
        value: w.id,
      }));
  }

  render() {
    const {
      timeUnits,
      interventionTime,
      interventionTimeUnit,
      planningDate,
      planningTime,
      preplanningDate,
      workerId,
      secondaryWorkerIds,
      planifConstraints,
      internalComment,
      status,
    } = this.props;

    const runningOrDone = ['RUNNING', 'CANCELED', 'EXECUTED', 'VALIDATED'];

    const done = ['EXECUTED', 'VALIDATED'];

    const disabledForStatus = statuses => statuses.includes(status);

    return (
      <Form>
        <Segment>
          <Form.Group>
            <Form.Field width={8}>
              <label>Pré planification</label>
              <PreplannificationInput
                name="preplanningDate"
                value={preplanningDate || ''}
                onChange={this.props.updatePreplanningDate}
                placeholder="Semaine"
                disabled={disabledForStatus(runningOrDone)}
              />
            </Form.Field>
            <Form.Field width={8}>
              <label>Durée de l'intervention</label>
              <Input
                value={interventionTime || ''}
                type="number"
                label={
                  <Dropdown
                    value={interventionTimeUnit}
                    options={timeUnits.map(tu => ({
                      key: tu.id,
                      text: tu.label,
                      value: tu.id,
                    }))}
                    basic
                    onChange={(_, value) =>
                      this.props.updateInterventionTimeUnit(value.value)
                    }
                  />
                }
                labelPosition="right"
                placeholder="Durée"
                onChange={evt =>
                  this.props.updateInterventionTime(
                    parseInt(evt.target.value, 0)
                  )
                }
                disabled={disabledForStatus(runningOrDone)}
              />
            </Form.Field>
          </Form.Group>
          <Form.Group>
            <Form.Field width={8}>
              <Form.Group>
                <Form.Field width={12}>
                  <label>Date de planification</label>
                  <CleanableDatepicker
                    identifier="date"
                    name="planningDate"
                    value={planningDate}
                    onChange={this.props.updatePlanningDate}
                    placeholder="JJ/MM/AAAA"
                    disabled={disabledForStatus(runningOrDone)}
                    hideButton={disabledForStatus(runningOrDone)}
                  />
                </Form.Field>
                <Form.Field width={4}>
                  <label>À</label>
                  <Timepicker
                    name="planningTime"
                    value={planningTime || ''}
                    onChange={this.props.updatePlanningTime}
                    disabled={disabledForStatus(runningOrDone)}
                  />
                </Form.Field>
              </Form.Group>
            </Form.Field>
            <Form.Field width={8}>
              <label>Technicien principal</label>
              <FormDropdown
                selection
                options={this._renderPrimaryWorkersOptions()}
                value={workerId}
                onChange={(_, value) => this.props.updateWorkerId(value.value)}
                disabled={disabledForStatus(done)}
              />
            </Form.Field>
          </Form.Group>
          <Form.Group>
            <Form.Field width={16}>
              <label>Techniciens secondaires</label>
              <FormDropdown
                selection
                multiple
                options={this._renderSecondaryWorkersOptions()}
                value={secondaryWorkerIds}
                onChange={(_, value) =>
                  this.props.updateSecondaryWorkerIds(value.value)
                }
                disabled={disabledForStatus(done)}
              />
            </Form.Field>
          </Form.Group>
          <Form.Group>
            <Form.Field width={16}>
              <label>Contrainte de planification</label>
              <input
                type="text"
                value={planifConstraints || ''}
                onChange={event =>
                  this.props.updatePlanifConstraints(event.target.value)
                }
                disabled={disabledForStatus(done)}
              />
            </Form.Field>
          </Form.Group>
          <Form.Group>
            <Form.Field width={16}>
              <label>Commentaire interne</label>
              <TextArea
                value={internalComment || ''}
                onChange={event =>
                  this.props.updateInternalComment(event.target.value)
                }
              />
            </Form.Field>
          </Form.Group>
        </Segment>
      </Form>
    );
  }
}

Page.propTypes = {
  id: PropTypes.number.isRequired,
  timeUnits: PropTypes.array.isRequired,
  fetchRequirements: PropTypes.func.isRequired,
  fetchForm: PropTypes.func.isRequired,
  updatePlanningDate: PropTypes.func.isRequired,
  updatePlanningTime: PropTypes.func.isRequired,
  updateInterventionTime: PropTypes.func.isRequired,
  updateInterventionTimeUnit: PropTypes.func.isRequired,
  updatePreplanningDate: PropTypes.func.isRequired,
  updateWorkerId: PropTypes.func.isRequired,
  updateSecondaryWorkerIds: PropTypes.func.isRequired,
  updatePlanifConstraints: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(Page);



// WEBPACK FOOTER //
// ./src/modules/saas/aast/interventions/components/Page.js